import { Link } from 'react-router-dom';
import LanguageSelector from '../components/LanguageSelector';
import useTranslation from '../data/useTranslation';

function Terms() {
  const { t } = useTranslation();
  const l = t.legal;

  return (
    <div className="min-h-screen bg-[#111827] text-white" data-testid="terms-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-[#111827]/95 backdrop-blur-md border-b border-gray-800">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center space-x-2" data-testid="terms-home-link">
            <span className="text-2xl font-bold text-orange-500">BPM</span>
            <span className="hidden sm:inline text-sm text-gray-500">Beyond Personal Matrix</span>
          </Link>
          <LanguageSelector />
        </div>
      </header>

      <main className="max-w-3xl mx-auto py-32 px-6 prose prose-invert">
        <h1 className="text-4xl sm:text-5xl font-bold mb-8 text-orange-500" data-testid="terms-title">
          {l.terms.title}
        </h1>
        <p className="text-gray-300 text-lg leading-relaxed" data-testid="terms-body">
          {l.terms.body}
        </p>
        <p className="mt-6 text-gray-400">
          <span className="font-semibold">{l.contactLabel} :</span>{' '}
          <a href={`mailto:${l.contactEmail}`} className="text-orange-400 hover:underline">
            {l.contactEmail}
          </a>
        </p>
        <Link to="/" className="inline-block mt-10 text-orange-400 hover:underline text-sm" data-testid="terms-back-link">
          ← {l.backToHome}
        </Link>
      </main>

      <footer className="py-8 border-t border-gray-800">
        <div className="container mx-auto px-6 text-center text-sm text-gray-600">
          {t.landing.copyright}
        </div>
      </footer>
    </div>
  );
}

export default Terms;
